
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import videojs from 'video.js';
import frenchLang from 'video.js/dist/lang/fr.json';

type PlayerOptions = typeof videojs.options;
type VideoPlayers = typeof videojs.players;

@Component
export default class VideoPlayer extends Vue {
  @Prop({ required: true }) source!: string;
  @Prop({ type: Boolean, default: true }) autoplay!: boolean;

  $refs!: {
    videoPlayer?: HTMLVideoElement;
  };

  player: VideoPlayers | null = null;

  async mounted() {
    await this.$nextTick();
    videojs.addLanguage('fr', frenchLang);
    this.videoOptions.language = this.$i18n.locale;
    if (this.$refs.videoPlayer)
      this.player = videojs(this.$refs.videoPlayer, this.videoOptions, () => {
        this.player?.on('contextmenu', event => event.preventDefault());
      });
  }

  beforeDestroy() {
    if (this.player) this.player.dispose();
  }

  get videoOptions(): PlayerOptions {
    return {
      autoplay: this.autoplay,
      controls: true,
      sources: [{ src: this.source, type: 'video/mp4' }],
      language: 'en',
      controlBar: {
        pictureInPictureToggle: false,
      },
    };
  }
}
